import { SECRET_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const LoginFormConfig = {
    submit: {
        label: "Actualizar Contraseña"
    },
    sections: [{
        hideBorderBottom: true,
        fields: [
            [
                {
                    "type": SECRET_INPUT_TYPE,
                    "name": "password",
                    "label": "Nueva Contraseña",
                    "isHorizontal": true,
                    "labelSizing": {
                        "sm": 5,
                        "md": 4
                    },
                    "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                }
            ],
        ]
    }]
};


export default LoginFormConfig;